<template>
  <div>
    <div class="page-box">
      <div class="tr">
        <el-button type="primary" @click="openDialog(null)" v-pms="'add'">添加服务类型</el-button>
      </div>
      <el-table
        :data="tableData"
        v-loading="tableDataLoading"
        border
        style="width: 100%">
        <el-table-column
          fixed
          prop="seqNum"
          label="排序号"
          width="250">
        </el-table-column>
        <el-table-column
          prop="name"
          label="服务类型"
          width="250">
        </el-table-column>
        <el-table-column
          prop="onFlag"
          label="是否上架"
          width="250">
          <el-switch slot-scope="{row}" :value="row.onFlag" @change="toggleOn(arguments[0], row)" v-pms="'tog'"></el-switch>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="150">
          <template slot-scope="scope">
            <el-button @click="openDialog(`${scope.$index}`)" type="text" size="small" v-pms="'edit'">编辑</el-button>
            <el-button @click="deleteServeType(scope.$index)" type="text" size="small" v-pms="'delete'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page.pageNum"
      :page-sizes="[10, 15, 20]"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total">
    </el-pagination>
    <el-dialog
      :title="editMsg"
      :visible.sync="dialogFormVisible"
      v-if="dialogFormVisible"
      :modal="false"
      :v-loading="submitting">
      <div class="add-form">
        <el-form
          ref="form"
          :model="dialogData"
          label-width="94px"
          :rules="rules">
          <el-form-item
            prop="name"
            label="服务类型"
          >
            <el-input type="text" v-model="dialogData.name" placeholder="请填写服务类型"></el-input>
          </el-form-item>
          <el-upload
            class="avatar-uploader"
            :action="imageApi"
            accept="image"
            :show-file-list="false"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :before-upload="beforeUpload">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <span v-if="!imageUrl" class="avatar-uploader-icon">点击上传图片</span>
          </el-upload>
          <el-form-item
            class="customizeCss"
            prop="seqNum"
            label="排序号"
          >
            <el-input type="number" v-model="dialogData.seqNum" placeholder="请填写排序号"></el-input>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input class="el-input"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入备注"
                      v-model="dialogData.remark">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" style="width: 100px;">关 闭</el-button>
        <el-button type="primary" @click="submitServeType" style="width: 100px;">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {serve} from '../../api'
import {validImage, toolbarOptions, quillUploadSuccess} from '@/utils'
import {getSession} from '../../utils/session'
import {ORG_CODE, USER_ID} from '../../constants'
export default {
  name: 'ServeTypeManage',
  data () {
    return {
      imageApi: process.env.VUE_APP_API + '/upload/image/single/',
      imageUrl: '',
      tableData: [],
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pages: 0
      },
      orgCode: getSession(ORG_CODE),
      userId: getSession(USER_ID),
      param: {
        orgCode: getSession(ORG_CODE)
      },
      tableDataLoading: false,
      submitting: false,
      editMsg: '',
      dialogFormVisible: false,
      dialogData: {
        serviceTypeId: '',
        name: '',
        servicePic: '',
        seqNum: '',
        servicePid: '',
        onFlag: '',
        remark: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入服务类型', trigger: 'blur'},
          {max: 10, message: '长度不能超过10个字符', trigger: 'blur'}
        ],
        seqNum: [
          {required: true, message: '请输入排序号', trigger: 'blur'}
        ],
        remark: [
          {message: '请输入备注', trigger: 'blur'},
          {max: 255, message: '长度不能超过255个字符', trigger: 'blur'}
        ]
      }
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    async getTableData () {
      this.tableDataLoading = true
      let {data, page} = await serve.pageServeType({
        param: this.param,
        page: this.page
      })
      this.tableDataLoading = false
      this.tableData = data
      this.page = page
    },
    handleSizeChange (val) {
      this.page.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.pageNum = val
      this.getTableData()
    },
    uploadSuccess (res, file) {
      this.loading = false
      this.imageUrl = process.env.VUE_APP_IMG + res.data
      this.dialogData.servicePic = res.data
    },
    uploadError () {
      this.loading = false
      this.$message({type: 'info', message: '插入图片失败，请稍后重试'})
    },
    beforeUpload (file) {
      this.loading = validImage(file, 500)
    },
    openDialog (index) {
      if (index == null) {
        this.editMsg = '添加服务类型'
        this.dialogData = {servicePid: '0'}
        this.imageUrl = ''
      } else {
        this.editMsg = '编辑服务类型'
        let data = this.tableData[index]
        delete data.createTime
        this.dialogData = data
        if (data.servicePic) {
          this.imageUrl = process.env.VUE_APP_IMG + data.servicePic
        } else {
          this.imageUrl = ''
        }
      }
      this.dialogFormVisible = true
    },
    async toggleOn (value, row) {
      let {code, msg} = await serve.toggleValid({serviceTypeId: row.serviceTypeId})
      if (code === 0) {
        row.onFlag = value
      } else {
        this.$message({
          type: 'error',
          message: msg
        })
      }
    },
    submitServeType () { // 添加编辑
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (!this.dialogData.servicePic) {
            this.$message({
              type: 'error',
              message: '请上传服务类型图片'
            })
            return false
          }
          if (!this.dialogData.serviceTypeId) {
            this.addServeType()
          } else {
            this.editServeType()
          }
        } else {
          return false
        }
      })
    },
    async addServeType () { // 添加方法
      this.submitting = true
      this.dialogData.orgCode = this.orgCode
      this.dialogData.createUser = this.userId
      this.dialogData.onFlag = true
      let {code, data, msg} = await serve.addServeType(this.dialogData)
      this.submitting = false
      this.dialogFormVisible = false
      if (code === 0) {
        this.$message({
          type: 'success',
          message: '服务类型添加成功'
        })
        this.getTableData()
      } else {
        this.$message({
          type: 'error',
          message: msg || '服务类型添加失败'
        })
      }
    },
    async editServeType () { // 编辑方法
      this.submitting = true
      let {code, msg} = await serve.updateServeType(this.dialogData)
      this.submitting = false
      this.dialogFormVisible = false
      if (code === 0) {
        this.$message({
          type: 'success',
          message: '服务类型修改成功'
        })
        this.getTableData()
      } else {
        this.$message({
          type: 'error',
          message: msg || '服务类型修改失败'
        })
      }
    },
    deleteServeType (index) {
      let serviceTypeId = this.tableData[index].serviceTypeId
      let name = this.tableData[index].name
      this.$confirm(`确定要删除服务类型[${name}]吗？`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let {code, msg} = await serve.delServeType({
          'serviceTypeId': serviceTypeId
        })
        if (code === 0) {
          this.$message({
            type: 'success',
            message: '服务类型删除成功'
          })
          this.tableData.splice(index, 1)
        } else {
          this.$message({
            type: 'error',
            message: msg || '服务类型删除失败'
          })
        }
      })
    }
  }

}
</script>
<style lang="scss" scoped>
  .el-form {
    width: 100%;
    max-width: 700px;
  }
</style>
<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader {
    margin: 0 0 20px 95px;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    display: block;
    font-size: 14px;
    color: #8c939d;
    width: 89px;
    height: 89px;
    line-height: 89px !important;;
    text-align: center;
  }

  .avatar {
    width: 89px;
    height: 89px;
    display: block;
  }
</style>
